// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";

// 引入跟组件
import App from "./App";

// 引入路由
import router from "../../router";

//导入路由菜单
import getRoute4Menu from "../../router/menu/daguanMenus";

//引入store
import store from "../../store";

// 引入rem.js
import '../../../static/scripts/plugin/rem_setting'

// 引入icon.js
import '../../assets/icon/iconfont'
import '../../assets/icon/iconfont2'
// import '../../assets/icon/iconfont3'
// import '../../assets/icon/iconfont4'
import '../../assets/icon/iconfont-new'
import '../../assets/icon/iconfont5'
import '../../assets/icon/iconfont-tool'
import '../../assets/icon/iconfont_yangshi'

import("babel-polyfill");

import VueI18n from 'vue-i18n'
import zh from '../../assets/js/i18n/langs/zh.js'
import en from '../../assets/js/i18n/langs/en.js'

import zhLocale from "view-design/src/locale/lang/zh-CN";
import enLocale from "view-design/src/locale/lang/en-US";

//使用引入
Vue.use(VueI18n);

Vue.locale = () => {}

if(!localStorage.getItem('lang')) localStorage.setItem('lang', 'zh')
// localStorage.setItem('lang', 'zh')

const i18n = new VueI18n({
  locale : localStorage.getItem('lang') || 'zh', // 语言
  messages: {  // 文案
    zh: Object.assign(zh, zhLocale),
    en: Object.assign(en, enLocale),
    // zh, // 文案的中文版
    // en // 文案的英文版
  }
})

Vue.config.productionTip = false;

// 引入iview前端框架
import iView from "view-design";
import "view-design/dist/styles/iview.css";

// Vue.use(iView);
Vue.use(iView, {
  i18n: (key, value) => i18n.t(key, value)
})

// 引入vue2-preview组件
import VuePreview from "vue2-preview";

Vue.use(VuePreview);

// 视频文件下载方法
Vue.prototype.$vodDownload = function (url) {
  if(!url) return;
  if(url.startsWith('http://')) url=url.replace('http://', 'https://');
  let arr = url.split('/');
  let fileName = arr[arr.length - 1];
  const a = document.createElement('a');
  a.href = `${url}?download_name=${fileName}`;
  a.click();
  window.URL.revokeObjectURL(a.href);
}

// 引入公共样式文件
//import '../static/assets/common/css/common.css';
import "../../../static/assets/common/css/common.css";

// 引入axios，发送http请求
import axios from "axios";

const httpAxios = axios.create();
httpAxios.defaults.withCredentials = true;
httpAxios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";
Vue.prototype.$axios = httpAxios;

//没有token的axios
Vue.prototype.$axiosNoToken = axios;

// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// Vue.prototype.$axios = axios;
// axios.defaults.withCredentials = true;

httpAxios.interceptors.response.use(
  (response) => {
    if ((response.data.status > 400) & (response.data.status < 404)) {
      //移除session用户和token相关信息
      store.commit("resetState");
      //退出登录
      loginOutUser();
      //return Promise.reject('break without exception.');
    } else {
      return response;
    }
  },
  (err) => {
    if (err.response && err.response.status == 401) {
      //如果为token已过期,跳转到登录页
      //移除session用户和token相关信息
      store.commit("resetState");

      //退出登录
      loginOutUser();
      //return Promise.reject('break without exception.');
    }

    return Promise.reject(err);
  }
);

// 请求的拦截器
httpAxios.interceptors.request.use(
  function (config) {
    config.params = {
      randomParam: Date.now(),
      ...config.params,
    };
    let token = store.getters.getToken;
    if (token) {
      config.headers["Authorization"] = token;
    }
    if(config.url.indexOf(process.env.live_conn_server_url4https) == -1 && config.url.indexOf(process.env.live_conn_server_url) == -1 && config.url.indexOf(process.env.live_conn_report_url4https) == -1 && config.url.indexOf(process.env.live_conn_report_url) == -1){
      config.headers["lang"] = localStorage.getItem('lang') == "en"?"en": "cn"
    }
    //console.log(config);
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

Vue.prototype.$Message.config({
  top: 100,
  duration: 3,
});
Vue.prototype.$Notice.config({
  top: 100,
  duration: 3,
});

import "../../../static/scripts/plugin/md5.js";

//对象存储Util
import * as cosUtil from "../../../src/assets/js/cosUtil";

Vue.prototype.$cosUtil = cosUtil;

//自定义权限指令
Vue.directive("has", {
  bind: function (el, binding) {
    if (!Vue.prototype.$_has(binding.value)) {
      $(el).hide();

      // var parentNode = el.parentNode;
      // if (parentNode)
      //   parentNode.removeChild(el);
    }
  },
});
//权限检查方法
Vue.prototype.$_has = function (value) {
  return RightUtil.hasRight(value);
  //return true;
};

import selfConfirm from "../../views/live/common";

Vue.use(selfConfirm);

//链接携带token时跳过登陆
var search = window.location.search;
var userCode = getSearchString('userCode', search); //结果：18
var sobeyToken = getSearchString('token', search); //结果：2

var ssUserCode = sessionStorage.getItem("ssUserCode");
var ssSobeyToken = sessionStorage.getItem("ssSobeyToken");
if (userCode && sobeyToken) {
  switchDaguanToken(userCode, sobeyToken);
} else if (ssUserCode && ssSobeyToken) {
  switchDaguanToken(ssUserCode, ssSobeyToken);
}

//交换大观的token
function switchDaguanToken(userCode, sobeyToken) {
  $.ajax({
    url: process.env.uc_server_url + "/login/noauth/token/sobey/switch?username=" + userCode + "&token=" + sobeyToken,
    type: "GET", //GET
    async: false, //或false,是否异步
    cache: false,
    dataType: "json", //返回的数据格式：
    success: function (result) {
      if (result.status == 200) {
        if (result.data != null) {
          //成功了，存储sobeytoken
          sessionStorage.setItem("ssUserCode", userCode);
          sessionStorage.setItem("ssSobeyToken", sobeyToken);
          store.dispatch("setToken", result.data.token);
          store.dispatch('setSkipCas', true);
          if (result.data.expired) {
            store.dispatch(
              "setTokenExpiredTime",
              new Date(result.data.expired).getTime()
            );
          }
          var tid = result.data.tid;
          var uid = result.data.uid;
          var usert = result.data.uset;
          var type = result.data.utype;
          var username = result.data.username;

          var userInfo = {};
          userInfo.tenantId = tid;
          userInfo.loginUserId = uid;
          userInfo.loginUsername = username;
          userInfo.userKey = usert;
          userInfo.userType = type;

          store.dispatch("setUserInfo", userInfo);
          store.dispatch("setUserId", uid);
          store.dispatch("setTenantId", tid);
          //设置token到vuex.state
          store.dispatch("setUserKey", usert);
          //除掉跳转参数
          var url1 = Util.DelUrlPara("userCode");
          if (url1) {
            var stateObject = {};
            var title = "";
            //修改地址栏中的地址
            history.pushState(stateObject, title, url1);

            var url2 = Util.DelUrlPara("token");
            if (url2) {
              //修改地址栏中的地址
              history.pushState(stateObject, title, url2);
            }
          }
        }
      } else {
        //失败就跳转到登录页
        alert("登录失败：" + result.msg);
        loginOutUser();
      }
    },
    error: function (error) {
      // alert("系统加载失败，请重试");
      loginOutUser();
    },
  });
}

//key(需要检索的键） url（传入的需要分割的url地址，例：?id=2&age=18）
function getSearchString(key, Url) {
  var str = Url;
  str = str.substring(1, str.length); // 获取URL中?之后的字符（去掉第一位的问号）
  // 以&分隔字符串，获得类似name=xiaoli这样的元素数组
  var arr = str.split("&");
  var obj = new Object();
  // 将每一个数组元素以=分隔并赋给obj对象
  for (var i = 0; i < arr.length; i++) {
    var tmp_arr = arr[i].split("=");
    obj[decodeURIComponent(tmp_arr[0])] = decodeURIComponent(tmp_arr[1]);
  }
  return obj[key];
}


router.beforeEach((to, from, next) => {
  checkLogin(to, from, next);
});

function checkLogin(to, from, next) {
  console.log(i18n.locale)
  if(localStorage.getItem('lang') && localStorage.getItem('lang') != i18n.locale){
    window.location.reload();
  }
  var token = store.getters.getToken;
  if (token) {
    if (next) {
      next();
    }
    return true;
  }

  var checkSuccess = true;
  var userInfoMap;
  var locationUrl =
    process.env.cas_url + "/login?service=" + process.env.service_name;
  $.ajax({
    url: process.env.user_url + "/all/userinfo",
    type: "GET", //GET
    async: false, //或false,是否异步
    cache: false,
    dataType: "json", //返回的数据格式：
    xhrFields: {
      withCredentials: true,
    },
    success: function (response) {
      if (response.commonResponse && response.commonResponse.success) {
        userInfoMap = JSON.stringify(response.userInfoMap);
        if (!userInfoMap || userInfoMap === null) {
          //退出登录
          loginOutUser();
        } else {
          let currentTid = sessionStorage.getItem('currentTid')
          if(currentTid != null) {
            response.userInfoMap.tenantId = currentTid
            response.userInfoMap.tid = currentTid
          }
          //设置到vuex state
          store.dispatch("setUserInfo", response.userInfoMap);
          //如果session中没有access_token，就获取token并设置到session中
          if (store.getters.getToken == null) {
            checkSuccess = setToken2State();
          }
          if (checkSuccess) {
            store.dispatch("setUserId", response.userInfoMap.uid);
            store.dispatch("setTenantId", response.userInfoMap.tid);
            //设置token到vuex.state
            store.dispatch("setUserKey", response.userInfoMap.userKey);
            var url = Util.DelUrlPara("ticket");
            if (url) {
              var stateObject = {};
              var title = "";
              //修改地址栏中的地址
              history.pushState(stateObject, title, url);
            }
            if (next) {
              next();
            }
            checkSuccess = true;
          } else {
            //退出登录
            loginOutUser();
          }
        }
      } else {
        alert("对不起，你没有权限登录此系统");
        window.location.href = locationUrl;
        checkSuccess = false;
      }
    },
    error: function (error) {
      // alert("系统加载失败，请重试");
      window.location.href = locationUrl;
      checkSuccess = false;
    },
  });
  return checkSuccess;
}

/**
 * 登出
 */
function loginOutUser() {
  var locationUrl =
    process.env.cas_url + "/logout?service=" + process.env.service_name;
  $.ajax({
    url: process.env.user_url + "/logout",
    type: "GET", //GET
    //async: false, //或false,是否异步
    cache: false,
    xhrFields: {
      withCredentials: true,
    },
    // success(resp){
    //   console.log("===resp===",resp)
    // }
  });
  window.location.href = locationUrl;
}

/**
 * 获取token并存储到session
 */
function setToken2State() {
  let success = false;
  let userInfo = store.getters.getUserInfo;
  if (userInfo == null) {
    return success;
  }

  let tid = userInfo.tenantId;
  let uid = userInfo.loginUserId;
  let userKey = userInfo.userKey;
  if (tid == null || uid == null || userKey == null) {
    return success;
  }

  let now = Date.now().toString();
  let secretStr = now + uid + userKey;
  let sign = md5(secretStr);
  let getTokenUrl =
    process.env.uc_server_url +
    "/login/token?uid=" +
    uid +
    "&tid=" +
    tid +
    "&tm=" +
    now +
    "&sign=" +
    sign+
    "&expiredMinutes=12000";

  //getTokenUrl = getTokenUrl + "&expiredMinutes=1"

  $.ajax({
    url: getTokenUrl,
    type: "GET", //GET
    async: false, //或false,是否异步
    cache: false,
    dataType: "json", //返回的数据格式：
    xhrFields: {
      withCredentials: true,
    },
    success: function (result) {
      if (result.status == 200) {
        if (result.data != null) {
          store.dispatch("setToken", result.data.token);
          if (result.data.expired) {
            store.dispatch(
              "setTokenExpiredTime",
              new Date(result.data.expired).getTime()
            );
          }
        }

        success = true;
      } else {
        //失败就跳转到登录页
        console.error("获取token失败", result);
        alert("获取token失败：" + result.msg);
      }
    },
    error: function (error) {
      console.error("获取token失败");
      if (error.status == 402) {
        //失败就跳转到登录页
        //window.location.href = locationUrl;
        console.error("获取token失败");
      }
    },
  });
  return success;
}

//加载权限
function loadRightsPromise(tid, uid) {
  return new Promise((resolve, reject) => {
    let rightUrl =
      process.env.uc_server_url +
      "/api/v1/user/getrights?tid=" +
      tid +
      "&uid=" +
      uid +
      "&ts=" +
      new Date().getTime();
    httpAxios({
      method: "get",
      url: rightUrl,
    })
      .then((res) => {
        if (res.status == 200 && res.data.status == 200) {
          resolve(res.data);
        } else {
          reject(res.data);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/// 加载iframe 用于获取cas登录以后用户相关信息
var newTimestamp = new Date().getTime();
$("#cas").html(
  "<iframe id='casIframe' src='" +
    process.env.user_url +
    "/index.html?random=" +
    newTimestamp +
    "' />"
);

let casIfrmae = document.getElementById("casIframe");

//保证获取cas加载完成以后再去获取用户信息
casIfrmae.onload = casIfrmae.onreadystatechange = function () {
  if (this.readyState && this.readyState != "complete") return;
  else {
    var login = checkLogin();
    if (login) {
      //加载权限信息
      let userInfo = store.getters.getUserInfo;
      if (userInfo == null) {
        sessionStorage.setItem("user_rights", JSON.stringify("[]"));
        new Vue({
          el: "#app",
          router,
          i18n,
          store, //使用store
          render: (h) => h(App),
        });
      }
      var tid = userInfo.tenantId;
      var uid = userInfo.loginUserId;

      let rightPromise = loadRightsPromise(tid, uid);

      //加载权限成功
      rightPromise
        .then((res) => {
          //设置session
          // res.data.push("daguan-director-control-open")
          sessionStorage.setItem("user_rights", JSON.stringify(res.data));
          //vue渲染App.vue
          // console.log(res.data)
          var rightRouters = getRoute4Menu(res.data);
          router.addRoutes(rightRouters);
          new Vue({
            el: "#app",
            router,
            i18n,
            store, //使用store
            render: (h) => h(App),
          });
        })
        .catch((err) => {
          if (err.status && err.status == 9006) {
            alert("对不起，您没有开通视频云服务。");
            sessionStorage.setItem("user_rights", JSON.stringify("[]"));
            new Vue({
              el: "#app",
              router,
              i18n,
              store, //使用store
              render: (h) => h(App),
            });
          } else {
            //加载权限失败
            console.error("加载权限信息失败", err);
            alert("加载权限信息失败，请联系管理员！！");
          }
        });

      //开启websocket（目前只有湖南日报项目用到）
      startWebsocket();
    }
  }
};

//只有湖南日报项目用到，用于监听租户和用户信息变化
function startWebsocket() {
  if (process.env.ENV_CONFIG == "hnrb" && "WebSocket" in window) {
    var websocket = new WebSocket(
      "wss://cas.voc.com.cn/main/message/websocket/" + uid + "-" + tid
    );
    websocket.onmessage = function (res) {
      var received_msg = res.data;
      console.info(received_msg);
      var received_json = JSON.parse(received_msg);
      console.info(received_json.messageType);
      if (
        received_json.messageType == 6 &&
        received_json.message.current_org_id != tid
      ) {
        console.info(received_json.message.current_org_id);
        console.info(tid);
        logoutUtil(process.env.user_url + "/logout");
        window.sessionStorage.removeItem("userInfo");
        websocket.close();
        window.location.reload();
      }
    };
  }
}

function logoutUtil(url) {
  $.ajax({
    method: "get",
    cache: false,
    url: url,
  });
}



// WEBPACK FOOTER //
// ./src/modules/daguan/main.js